import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';

gsap.registerPlugin(ScrollTrigger);

let splitInstances = [];

/**
 * Initializes text animations on designated elements.
 * Waits for fonts to load before calculating line splits.
 * 
 * @param {HTMLElement|Document} container The container to search within.
 */
export function initializeTextAnimations(container = document) {
    // Select elements that should have the line/word split animation
    const textElements = container.querySelectorAll('h1:not(.hero__title), h2:not(.hero__subtitle), h3, blockquote >p:first-child');

    if (textElements.length === 0) return;

    // Ensure splits aren't calculated until all fonts have been loaded
    document.fonts.ready.then(() => {
        textElements.forEach((el) => {
            // Check if already initialized to prevent duplicate splits
            if (el.classList.contains('is-split-initialized')) return;
            el.classList.add('is-split-initialized');

            // Split the text into lines and words
            const split = new SplitType(el, { types: 'lines, words', tagName: 'span' });
            splitInstances.push(split);

            // Stagger timing variable for the CSS
            const staggerAmount = 0.05;
            let wordIndex = 0;

            // Loop through lines instead of words so we process left-to-right, top-to-bottom
            if (split.lines) {
                split.lines.forEach((line) => {
                    // Extract words within this specific line
                    const wordsInLine = line.querySelectorAll('.word');
                    
                    wordsInLine.forEach((word) => {
                        const innerSpan = document.createElement('span');
                        innerSpan.className = 'word-inner';
                        innerSpan.style.setProperty('--word-delay', `${wordIndex * staggerAmount}s`);
                        
                        // Move all child nodes of the word into the inner span
                        while (word.firstChild) {
                            innerSpan.appendChild(word.firstChild);
                        }
                        
                        word.appendChild(innerSpan);
                        wordIndex++;
                    });
                });
            }
        });
        
        // Refresh ScrollTrigger after DOM changes to ensure start/end points are correct
        ScrollTrigger.refresh();
    });
}

/**
 * Destroys and cleans up text animations.
 */
export function destroyTextAnimations() {
    // Revert the DOM back to its original state so it can be re-initialized cleanly
    splitInstances.forEach(instance => {
        if (instance && typeof instance.revert === 'function') {
            instance.revert();
        }
    });
    splitInstances = [];

    // ScrollTrigger usually handles its own cleanup on refresh/kill but we can explicitly clear if needed
}
